"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EFx = void 0;

var EFx =
/** @class */
function () {
  function EFx() {}

  EFx.prototype.EFxModuleType = function () {
    return [{
      id: 'Activation',
      slug: 'guest-management',
      name: 'Guest Management',
      description: 'Activate a user in EFx via QR or NFC',
      isAccessControl: false,
      isGuestManagement: true,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/guest-management.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }, {
      id: 'AccessControl',
      slug: 'access-control',
      name: 'Access Control',
      description: 'Scan assets to grant access to exclusive event experiences',
      isAccessControl: true,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/access.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'AthleteBag',
      slug: 'athletes-bag',
      name: 'Athletes Bag',
      description: 'Custom module for Nike',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: true,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: true,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/nike.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }, {
      id: 'Concierge',
      slug: 'concierge',
      name: 'Concierge',
      description: 'Deliver key information to attendees when they scan assets at kiosk',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: true,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/concierge.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }, {
      id: 'DigitalMemoryBank',
      slug: 'digital-memory-bank',
      name: 'Digital Memory Bank',
      description: 'Create and share a personalized post-event content hub with your attendees',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: true,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/digital-memory-bank.png',
      dependencyNFC: false,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'GuestInfo',
      slug: 'guest-info',
      name: 'Guest Info',
      description: 'Custom diagnostic tool',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: true,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: true,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/access.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }, {
      id: 'Messaging',
      slug: 'messaging',
      name: 'Messaging',
      description: 'Engage attendees via SMS messaging',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: true,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/messaging.png',
      dependencyNFC: false,
      dependencySMS: true,
      compatibilityNFC: false,
      compatibilitySMS: true
    }, {
      id: 'SMSQuiz',
      slug: 'smsquiz',
      name: 'Poll',
      description: 'Text guests via SMS. View responses in EFx mobile app and Apple TV app',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: true,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/polling.png',
      dependencyNFC: false,
      dependencySMS: true,
      compatibilityNFC: false,
      compatibilitySMS: true
    }, {
      id: 'ProductPickup',
      slug: 'product-pickup',
      name: 'Product Pickup',
      description: 'Scan asset to confirm attendees&#039; eligibility to receive or purchase products',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: true,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/product-pickup.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'Raffle',
      slug: 'raffle',
      name: 'Raffle',
      description: 'Select prize winners and notify them via SMS',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: true,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/raffle.png',
      dependencyNFC: true,
      dependencySMS: true,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'Reservation',
      slug: 'reservation',
      name: 'Reservation',
      description: 'Queue attendees in a virtual line and notify them via SMS when availability opens',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: true,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/reservation.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'RoamingPhotographer',
      slug: 'roaming-photographer',
      name: 'Roaming Photographer',
      description: 'Take photo and apply custom event filters. Deliver images via SMS',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: true,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/photographer.png',
      dependencyNFC: false,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: true
    }, {
      id: 'SmartBar',
      slug: 'smart-bar',
      name: 'Smart Bar',
      description: 'Attendees scan assets at bar kiosks to place orders in bartender queue',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: true,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/smartbar-vertical.png',
      dependencyNFC: true,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }, {
      id: 'Teams',
      slug: 'teams',
      name: 'Teams',
      description: 'Build attendee teams for competition, collaboration, and networking; track scores on the leaderboard',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: true,
      isLeadRetrieval: false,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/teams.png',
      dependencyNFC: false,
      dependencySMS: false,
      compatibilityNFC: false,
      compatibilitySMS: true
    }, {
      id: 'LeadRetrieval',
      slug: 'lead-retrieval',
      name: 'Lead Retrieval',
      description: 'Get leads for your events',
      isAccessControl: false,
      isGuestManagement: false,
      isConcierge: false,
      isAthleteBag: false,
      isDigitalMemoryBank: false,
      isGuestInfo: false,
      isMessaging: false,
      isProductPickup: false,
      isRaffle: false,
      isReservation: false,
      isRoamingPhotographer: false,
      isSmartBar: false,
      isSmsQuiz: false,
      isTeams: false,
      isLeadRetrieval: true,
      isAdminOnly: false,
      iconURL: 'https://cdn.eventfarm.com/platform/img/icons/lead-retrieval.png',
      dependencyNFC: false,
      dependencySMS: false,
      compatibilityNFC: true,
      compatibilitySMS: false
    }];
  };

  EFx.prototype.EFxScreenType = function () {
    return [{
      slug: 'scan-view',
      name: 'Scan View',
      description: null,
      isScanView: true,
      isFailureView: false,
      isCheckOutView: false,
      isSuccessView: false,
      isRegisterSuccessView: false,
      isRegisterScanView: false,
      isRegisterFailureView: false
    }, {
      slug: 'failure-view',
      name: 'Failure View',
      description: null,
      isScanView: false,
      isFailureView: true,
      isCheckOutView: false,
      isSuccessView: false,
      isRegisterSuccessView: false,
      isRegisterScanView: false,
      isRegisterFailureView: false
    }, {
      slug: 'check-out-view',
      name: 'Check Out View',
      description: null,
      isScanView: false,
      isFailureView: false,
      isCheckOutView: true,
      isSuccessView: false,
      isRegisterSuccessView: false,
      isRegisterScanView: false,
      isRegisterFailureView: false
    }, {
      slug: 'success-view',
      name: 'Success View',
      description: null,
      isScanView: false,
      isFailureView: false,
      isCheckOutView: false,
      isSuccessView: true,
      isRegisterSuccessView: false,
      isRegisterScanView: false,
      isRegisterFailureView: false
    }, {
      slug: 'register-success-view',
      name: 'Register Success View',
      description: null,
      isScanView: false,
      isFailureView: false,
      isCheckOutView: false,
      isSuccessView: false,
      isRegisterSuccessView: true,
      isRegisterScanView: false,
      isRegisterFailureView: false
    }, {
      slug: 'register-scan-view',
      name: 'Register Scan View',
      description: null,
      isScanView: false,
      isFailureView: false,
      isCheckOutView: false,
      isSuccessView: false,
      isRegisterSuccessView: false,
      isRegisterScanView: true,
      isRegisterFailureView: false
    }, {
      slug: 'register-failure-view',
      name: 'Register Failure View',
      description: null,
      isScanView: false,
      isFailureView: false,
      isCheckOutView: false,
      isSuccessView: false,
      isRegisterSuccessView: false,
      isRegisterScanView: false,
      isRegisterFailureView: true
    }];
  };

  EFx.prototype.EFxStationType = function () {
    return [{
      slug: 'check-in',
      name: 'CheckIn',
      description: null,
      isCheckIn: true,
      isCheckInOut: false
    }, {
      slug: 'check-in-out',
      name: 'CheckInOut',
      description: null,
      isCheckIn: false,
      isCheckInOut: true
    }];
  };

  return EFx;
}();

exports.EFx = EFx;